import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Dropdown,
  Menu,
  Row,
  Table,
  Tooltip,
  Spin,
  notification,
  Modal,
  Popconfirm,
} from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import moment from "moment";
import {
  PrinterOutlined,
  MoreOutlined,
  EditOutlined,
  CheckCircleOutlined,
  StopOutlined,
  DeleteFilled,
  FolderOpenOutlined,

  CloseSquareOutlined,

  SwapOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import "../Pages/CSS/Traitement.css";
import { GestionPaieService } from "../Services/GestionPaieService";
import PassationModal from "./Modal_Doc/PassationModal";
import DuplicataModal from "./Modal_Doc/DuplicataModal";

const Bulletins = () => {

  const gestionPaieService = new GestionPaieService();

  const [duplicataVisible, setDuplicataVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCalculActive, setIsCalculActive] = useState(false);
  const [debut, setDebut] = useState(null);
  const [fin, setFin] = useState(null);
  const [etat, setEtat] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const userProfil = localStorage.getItem("profil");

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const bulletins = await gestionPaieService.getAllBulletins();
      const bulletinsWithKeys = bulletins.map((item, index) => ({
        ...item,
        key: index,
      }));
      setTableData(bulletinsWithKeys);
      if (bulletins.length > 0) {
        const {
          debut: debutBulletin,
          fin: finBulletin,
          etat: etatBulletin,
        } = bulletins[0];
        setDebut(debutBulletin);
        setFin(finBulletin);
        setEtat(etatBulletin);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des données.",
      });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const formatPeriode = useCallback((start, end) => {
    const startDate = moment(start);
    const endDate = moment(end);
    return `${startDate.format("D MMMM YYYY")} - ${endDate.format(
      "D MMMM YYYY"
    )}`;
  }, []);

  const handlePrintPDF = useCallback(
    (numbull) => {
      gestionPaieService.printBulletinsService(numbull);
    },
    [gestionPaieService]
  );

  const handlePrint = useCallback(
    (type) => {
      switch (type) {
        case "bulletins":
          gestionPaieService.printBulletins();
          break;
        case "virements":
          gestionPaieService.printVirementSalaire();
          break;
        case "cheques":
          gestionPaieService.printLettreChequeSAL();
          break;
        case "cotisations":
          gestionPaieService.printCotisations();
          break;
        default:
          break;
      }
    },
    [gestionPaieService]
  );

  const handleEdit = (record) => {
    navigate(`/gestion-paie/edit/${record.numbull}`, { state: { record } });
  };
  useEffect(() => {
    const hasActiveCalcul = tableData.some((item) => item.calcul === true);
    setIsCalculActive(hasActiveCalcul);
  }, [tableData]);

  const gestionMenu = (
    <Menu>
      <Menu.Item
        key="1"
        disabled={!isCalculActive || etat !== "ouvert"}
        onClick={() => handlePrint("bulletins")}
      >
        Bulletins
      </Menu.Item>
      <Menu.Item
        key="2"
        disabled={!isCalculActive || etat !== "ouvert"}
        onClick={() => handlePrint("virements")}
      >
        Virements
      </Menu.Item>
      <Menu.Item
        key="3"
        disabled={!isCalculActive || etat !== "ouvert"}
        onClick={() => handlePrint("cheques")}
      >
        Chéques
      </Menu.Item>
      <Menu.Item
        key="4"
        disabled={!isCalculActive || etat !== "ouvert"}
        onClick={() => handlePrint("cotisations")}
      >
        Cotisations
      </Menu.Item>
    </Menu>
  );

  const handleOpenMensuel = async () => {
    try {
      setIsLoading(true);
      const payload = {
        numparam: "param1",
        perim: "IPM",
      };
      await gestionPaieService.openMensuel(payload);
      notification.success({
        message: "Ouverture mensuelle réussie",
      });
      setEtat("ouvert"); // Met à jour l'état après l'ouverture
      fetchData();
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Échec de l'ouverture mensuelle.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseMensuel = async () => {
    const startDate = moment(debut);
    const endDate = moment(fin);

    Modal.confirm({
      title: "Clôture Mensuelle",
      content: `Voulez-vous vraiment clôturer la période du ${startDate.format(
        "D MMMM YYYY"
      )} au ${endDate.format("D MMMM YYYY")}?`,
      okText: "Oui",
      cancelText: "Non",
      onOk: async () => {
        try {
          setIsLoading(true);

          const payload = tableData;
          const response = await gestionPaieService.closeMensuel(payload);

          if (response.Closed === false) {
            notification.error({
              message: "Non clôturé",
              description:
                "Veuillez effectuer la passation comptable avant clôture.",
            });
          } else {
            notification.success({
              message: "Clôture mensuelle réussie",
            });
            setEtat("fermé"); // Met à jour l'état après la clôture
            fetchData();
          }
        } catch (error) {
          notification.error({
            message: "Erreur",
            description: "Échec de la clôture mensuelle.",
          });
        } finally {
          setIsLoading(false);
        }
      },
      onCancel() {
        console.log("Clôture mensuelle annulée");
      },
    });
  };

  const handleDelete = async (numbull) => {
    try {
      await gestionPaieService.deletePaie(numbull);
      await fetchData();
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
    }
  };


  const columns = [
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "5px",
          }}
        ></div>
      ),
      dataIndex: "calcul",
      key: "calcul",
      align: "center",
      sorter: (a, b) => Number(a.calcul) - Number(b.calcul),
      render: (calcul) =>
        calcul ? (
          <CheckCircleOutlined style={{ color: "green" }} />
        ) : (
          <StopOutlined style={{ color: "red" }} />
        ),
    },
    {
      title: "Matricule",
      dataIndex: "matrisal",
      key: "matrisal",
      align: "center",
      sorter: (a, b) => {
        if (!a.matrisal && b.matrisal) return 1;
        if (a.matrisal && !b.matrisal) return -1;
        if (!a.matrisal && !b.matrisal) return 0;
        return a.matrisal.localeCompare(b.matrisal);
      },
    },
    {
      title: "Civilité",
      dataIndex: "civilite",
      key: "civilite",
      sorter: (a, b) => {
        if (!a.civilite && b.civilite) return 1;
        if (a.civilite && !b.civilite) return -1;
        if (!a.civilite && !b.civilite) return 0;
        return a.civilite.localeCompare(b.civilite);
      },
    },
    {
      title: "Nom",
      dataIndex: "nom",
      key: "nom",
      sorter: (a, b) => {
        if (!a.nom && b.nom) return 1;
        if (a.nom && !b.nom) return -1;
        if (!a.nom && !b.nom) return 0;
        return a.nom.localeCompare(b.nom);
      },
    },
    {
      title: "Prénom(s)",
      dataIndex: "prenoms",
      key: "prenoms",
      sorter: (a, b) => {
        if (!a.prenoms && b.prenoms) return 1;
        if (a.prenoms && !b.prenoms) return -1;
        if (!a.prenoms && !b.prenoms) return 0;
        return a.prenoms.localeCompare(b.prenoms);
      },
    },
    {
      title: "Période",
      render: (record) => formatPeriode(record.debut, record.fin),
      sorter: (a, b) => {
        const dateA = new Date(a.debut).getTime();
        const dateB = new Date(b.debut).getTime();
        return dateA - dateB;
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      dataIndex: "actions",
      key: "actions",
      align: "center",
      fixed: "right",
      render: (text, record) => (
        <span>
          {record.calcul && (
            <>
              <Tooltip title="Imprimer">
                <PrinterOutlined
                  style={{
                    cursor: "pointer",
                    color: "#67f02e",
                    marginRight: 8,
                  }}
                  onClick={() => handlePrintPDF(record.numbull)}
                  aria-label={`Imprimer le bulletin de ${record.nom} ${record.prenoms}`}
                />
              </Tooltip>
            </>
          )}
          {userProfil !== "role_15" &&
            userProfil !== "role_3" &&
            userProfil !== "role_4" &&
            userProfil !== "role_5" && (
              <>
                <Tooltip title="Modifier">
                  <EditOutlined
                    style={{
                      cursor: "pointer",
                      color: "orange",
                      marginRight: 8,
                    }}
                    onClick={() => handleEdit(record)}
                  />
                </Tooltip>

                <Popconfirm
                  title="Êtes-vous sûr de vouloir supprimer cet élément?"
                  onConfirm={() => handleDelete(record.numbull)}
                  okText="Oui"
                  cancelText="Non"
                >
                  <Tooltip title="Supprimer">
                    <DeleteFilled
                      style={{ cursor: "pointer", color: "red" }}
                    />
                  </Tooltip>
                </Popconfirm>
              </>
            )}
        </span>
      ),
    },
  ];


  return (
    <div style={{ padding: 0, margin: 0 }}>
      <Card
        className="card-container"
        title={
          <Paragraph>
            Période du {formatPeriode(tableData[0]?.debut, tableData[0]?.fin)}
          </Paragraph>
        }
        extra={
          userProfil !== "role_15" &&
          userProfil !== "role_3" &&
          userProfil !== "role_4" &&
          userProfil !== "role_5" && (
            <Row gutter={[8, 8]} align="middle" justify="end">
              <Col>
                <Button
                  style={{ marginRight: "10px" }}
                  disabled={etat === "ouvert"}
                  onClick={handleOpenMensuel} // Associer la fonction handleOpenMensuel
                  icon={<FolderOpenOutlined />}
                  className="buttonOpen"
                >
                  Ouverture Mensuelle
                </Button>
              </Col>
              <Col>
                <Button
                  style={{ marginRight: "10px" }}
                  disabled={etat !== "ouvert"}
                  onClick={handleCloseMensuel} // Associer la fonction handleCloseMensuel
                  icon={<CloseSquareOutlined />}
                  className="buttonClose"
                >
                  Clôture Mensuelle
                </Button>
              </Col>
              <Col>
                <Button
                  icon={<SwapOutlined />}
                  onClick={() => setModalVisible(true)}
                  disabled={etat !== "ouvert"}
                  className="buttonCloture"
                >
                  Passation Comptable
                </Button>
              </Col>
              <Col>
                <Button
                  icon={<CopyOutlined />}
                  onClick={() => setDuplicataVisible(true)}
                  className="buttonDuplicate"
                >
                  Duplicata
                </Button>
              </Col>
              <Col>
                <Dropdown overlay={gestionMenu} trigger={["click"]}>
                  <Button className="buttonImport">
                    Édition
                    <MoreOutlined />
                  </Button>
                </Dropdown>
              </Col>
            </Row>
          )
        }
      >
        <Spin spinning={isLoading}>
          <Table
            columns={columns}
            dataSource={tableData}
            scroll={{ x: true }}
            style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
            className="custom-header1-table"
            bordered
            showSorterTooltip={false}
            pagination={{
              pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
              showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
              pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
              onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
            }}
          />
        </Spin>
      </Card>
      <PassationModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        debut={debut}
        fin={fin}
      />
      <DuplicataModal
        visible={duplicataVisible}
        onClose={() => setDuplicataVisible(false)}
      />
    </div>
  );
};

export default Bulletins;
